module.exports = function () {
  var html = "\n      <div class=\"pay-overlay\" id=\"pay-overlay\">\n\t<div class=\"qrcode\"></div>\n\t<div class=\"address\">address</div>\n\t<div class=\"amount\">0.0413123 ETH</div>\n\t<div class=\"instructions\">please submit the payment</div>\n      </div>\n  ";
  return html;
};